import Link from "next/link";
import { A, Text } from "@nju/ui";

interface IRichRowProps extends IRichRowLinkProps {
  title: string;
  value: string;
}

interface IRichRowLinkProps {
  link: string;
  id: string;
}

interface IRichRowTitleProps {
  title: string;
}

export function RichRowLink({ link, id }: IRichRowLinkProps) {
  return (
    <Link href={link} passHref={true}>
      <A data-test-id={id} display="inline" size="inline" variant="simple">
        <Text
          className="ml-2"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
          tone="accent"
          weight="bold"
          withUnderline={true}
        >
          zmień
        </Text>
      </A>
    </Link>
  );
}

export function RichRowTitle({ title }: IRichRowTitleProps) {
  return (
    <Text
      display="block"
      size={{
        "@onlyMobile": "s",
        "@fromTablet": "m",
      }}
    >
      {title}
    </Text>
  );
}

export function RichRow({ title, value, link, id }: IRichRowProps) {
  return (
    <>
      <RichRowTitle title={title} />
      <div className="flex justify-between only-mobile:items-center">
        <Text
          breakLongValue="force"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
          weight="bold"
        >
          {value}
        </Text>
        <RichRowLink id={id} link={link} />
      </div>
    </>
  );
}
